import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

export {
  useTranslation as useTransl,
  withTranslation as withTransl,
  Trans,
} from 'react-i18next';

export { useMuiPickerLocale } from './useMuiPickerLocale';

export const supportedLngs = {
  en: 'en',
  fr: 'fr',
};

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: supportedLngs.en,
    supportedLngs: [supportedLngs.en, supportedLngs.fr], // to avoid 404 errors for unsupported languages
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      order: [
        'querystring',
        'cookie',
        'navigator',
        'localStorage',
        'sessionStorage',
        'htmlTag',
      ],
      convertDetectedLanguage: (lng) => {
        if (lng?.includes('en')) return 'en';
        if (lng?.includes('fr')) return 'fr';
        return 'en';
      },
    },
  });

export default i18n;
